<template>
  <el-form ref="presidentJudgmσentForm" label-width='180px' v-model='presidentJudgement' :disabled="isSaving">
    <el-form-item :label="gradeLabel()" v-if="!isReappraisal && this.workingApplication.grade"
      class="compact-form-item">
      {{this.workingApplication.grade}}
    </el-form-item>
    <el-form-item v-if="!isReappraisal && this.workingApplication.grade_description" :label="gradeDescriptionLabel()"
      class="compact-form-item">
      {{this.workingApplication.grade_description}}
    </el-form-item>
    <el-form-item v-if="!isReappraisal && this.workingApplication.certificationTitleByInternal" label="Τίτλος Σπουδών"
      class="compact-form-item">
      {{this.workingApplication.certificationTitleByInternal}}
    </el-form-item>
    <el-form-item v-if="this.workingApplication.consideration && this.workingApplication.considerationTitleByInternal" label="Τίτλος Σπουδών (Συνυποβολή)"
      class="compact-form-item">
      {{this.workingApplication.considerationTitleByInternal}}
    </el-form-item>
    <el-form-item v-if="isReappraisal && this.workingApplication.overdue">
      <el-alert :closable="false" type="warning" :title="OVERDUE_MESSAGE" show-icon=""
        style="border: 1px solid; background-color: #fdf6ec;">
      </el-alert>
    </el-form-item>
    <el-form-item label="Κατηγορία αίτησης" v-if="isReappraisal">
      <el-switch disabled v-model="workingApplication.legalIssue"
        active-text="Νομικό ζήτημα" inactive-text="Ακαδημαϊκό ζήτημα">
      </el-switch>
    </el-form-item>
    <internalComments v-if="!fromPrintDecision"></internalComments>
    <proposals v-if="fromProponent || fromAcademicDirector || fromBoard || fromVice || fromConsultant || fromConsultantOverdue || fromAcademicDirector2 || fromSpecialReappraisalBoard || evaluatorsToPay.length !== 0"></proposals>
    <el-form-item label="Εισήγηση Δ/ντή Αναγν/σης" size="large" v-if="fromAcademicDirector">
      <el-input
        type="textarea"
        disabled
        :autosize="{ minRows: 2, maxRows: 4}"
        v-model="academicDirectorJudgment.proposal">
      </el-input>
    </el-form-item>
    <el-form-item label="Αντισταθμιστικά μέτρα" size="large" v-if="fromAcademicDirector2">
      <el-input
        type="textarea"
        disabled
        :autosize="{ minRows: 2, maxRows: 4}"
        v-model="academicDirectorJudgment.proposal">
      </el-input>
    </el-form-item>
    <div v-if="fromViewer || fromSpecialReappraisalBoard">
      <hr v-if="isReappraisal" style="margin-top: 20px;">
      <el-form-item label="Ενέργειες επανεξέτασης" v-if="isReappraisal">
        <el-form-item v-if="workingApplication.overdue">
          <el-checkbox
            label='Αποδοχή εκπρόθεσμης αίτησης για επανεξέταση'
            v-model='presidentJudgement.acceptOverdue'
            @change="toggleOverdue">
          </el-checkbox>
        </el-form-item>
        <el-form-item v-if="!workingApplication.overdue || presidentJudgement.acceptOverdue">
          <reappraisal-board-selector
            v-if="isAvailableEmployeesLoaded"
            :people="availableEmployees"
            :fixed-ids="fixedMembers"
            :initial-leader="leaderId"
            :initialSelected="selectedEmployees"
            @board-changed="handleBoardChange">
          </reappraisal-board-selector>
        </el-form-item>
      </el-form-item>
      <hr v-if="isReappraisal" style="margin-bottom: 20px;">
    </div>
    <div v-if="fromPrechecker">
      <el-form-item label="Εκπρόθεσμη" v-if="isReappraisal">{{ overdue}}</el-form-item>
      <!-- can be taken to a sub-component -->
      <el-form-item label="Απόφαση Δ.Σ." v-if="isReappraisal">
        <el-input type="textarea" :rows="2" placeholder="Παρακαλώ εισάγετε την απόφαση του ΔΣ" v-model="presidentJudgement.decisionOverdue">
        </el-input>
      </el-form-item>
      <el-form-item v-if="isReappraisal && this.workingApplication.overdue">
        <el-checkbox label='Αποδοχή εκπρόθεσμης αίτησης' v-model='presidentJudgement.acceptOverdue' @change="toggleOverdue"></el-checkbox>
      </el-form-item>
      <el-form-item label= "Προτεινόμενη Ακαδ.Περιοχή" v-if="!isReappraisal">
          <el-input v-model="precheckerJudgement.academicField.name" disabled size="large"></el-input>
      </el-form-item>
      <el-form-item label= "Ακαδημαϊκη Περιοχή" v-if="isReappraisal">
        {{ workingApplication.relevantAppl.academicField.name }}
      </el-form-item>
      <el-form-item v-if="!isReappraisal" size="large">
        <el-checkbox label='Αποδοχή Προτ.Ακαδημαϊκής Περιοχής' v-model="checked" @change="toggleChecked">
        </el-checkbox>
      </el-form-item>
      <el-form-item label="Ορισμός νέας Ακαδημαϊκής Περιοχής" size="large" v-if="!isReappraisal && checked === false">
        <el-select
          class="bigger"
          v-model="presidentJudgement.academicField.name"
          filterable
          @change="toggleAcademicField"
          placeholder='Ακαδημαϊκή Περιοχή'>
          <el-option v-for="area in academicAreas"
            :key="area.id"
            :value="area.id"
            :label="area.name"
            filterable>
          </el-option>
        </el-select>
      </el-form-item>
      <!-- <el-form-item v-if="!isReappraisal" label="Επιλογή Χειριστή">
        <el-select
          v-model="presidentJudgement.assignedTo.uid"
          filterable
          placeholder="Παρακαλώ Επιλέξτε"
          @change='toggleSpecialProponent'>
          <el-option v-for="specialProponent in specialProponents"
            :key="specialProponent.id"
            :label="specialProponent.firstname + ' ' + specialProponent.surname"
            :value="specialProponent.id"
            filterable>
          </el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item label="Ανάθεση σε Αντιπρόεδρο"
        v-if="isReappraisal && !isSecondReappraisal && presidentJudgement.acceptOverdue">
        <el-select v-model="presidentJudgement.assignedTo.role" placeholder="Παρακαλώ Επιλέξτε">
          <el-option label="Αντιπρόεδρος Α" value="VicePresidentA"></el-option>
          <el-option label="Αντιπρόεδρος Β" value="VicePresidentB"></el-option>
        </el-select>
      </el-form-item>
    </div>
    <div v-if="fromBoard">
      <!-- can be taken to a sub-component -->
      <el-table :data="judgementFromBoardMembers" style="width: 100%">
        <el-table-column label="Όνομα"  width="140">
          <template slot-scope="scope">
            <span>{{ scope.row.firstname }}</span>
          </template>
        </el-table-column>
        <el-table-column label="Επώνυμο"  width="140">
          <template slot-scope="scope">
            <span>{{ scope.row.surname }}</span>
          </template>
        </el-table-column>
        <el-table-column v-if="isReappraisal" label="Πλήρης αποδοχή επανεξ.">
            <template slot-scope="scope">
              <el-button type="success" icon="el-icon-check"
                circle v-if="scope.row.fullyAgreeWithReappraisal">
              </el-button>
              <el-button type="danger" icon="el-icon-close"
                circle v-if="!scope.row.fullyAgreeWithReappraisal">
              </el-button>
            </template>
        </el-table-column>
        <el-table-column v-if="!isReappraisal" label="Αποδοχή πρότασης" width="205">
          <el-table-column label="Χειριστή"  width="95">
            <template slot-scope="scope">
              <el-button type="success" icon="el-icon-check"
                circle v-if="scope.row.agreeWithProponent">
              </el-button>
              <el-button type="danger" icon="el-icon-close"
                circle v-if="scope.row.agreeWithProponent===false">
              </el-button>
            </template>
          </el-table-column>
          <el-table-column label="Ακαδημαϊκού Συμβούλου"  width="110" v-if='fromConsultant'>
            <template slot-scope="scope">
              <el-button type="success" icon="el-icon-check" circle v-if="scope.row.agreeWithAC">
              </el-button>
              <el-button type="danger" icon="el-icon-close" circle
                v-if="scope.row.agreeWithAC===false">
              </el-button>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="Εισήγηση">
          <template slot-scope="scope">
            <span>{{ scope.row.proposal }}</span>
          </template>
        </el-table-column>
        <el-table-column label="Σχόλιο">
          <template slot-scope="scope">
            <span>{{ scope.row.comment }}</span>
          </template>
        </el-table-column>
      </el-table>
      <hr>
    </div>
    <div v-if="fromVice">
      <h4>Απόφαση Συνεδρίασης Τμήματος:</h4>
      <el-input v-model="judgementFromVice.comment"  type="textarea" disabled size="large"></el-input>
    </div>
    <president-decision
      v-if="showDecision"
      :validatedFinalDecisions="validatedFinalDecisions"
      :presidentJudgement="presidentJudgement"
      :titlesCorrespondence = "titlesCorrespondence"
      :fromConsultant = fromConsultant
      :fromConsultant2 = fromConsultant2
      :fromConsultantOverdue = fromConsultantOverdue
      :fromBoard = fromBoard
      :fromProponent = fromProponent
      :fromAcademicDirector = fromAcademicDirector
      :fromVice = fromVice
      :fromViceThroughBoard = fromViceThroughBoard
      :fromViceThroughReappraisalBoard = fromViceThroughReappraisalBoard
      :fromAcademicDirector2 = fromAcademicDirector2
      :fromAcademicDirectorReappraisal = fromAcademicDirectorReappraisal
      :reappDegreeType = "reappDegreeType"
      :reappraise = reappraise
      :isPostExam = "isPostExam"
      :isSecondReappraisal = isSecondReappraisal
      @changedPresidentDecision="changedPresidentDecisionEvent"
      @changedPresidentReappraisalDecision="changedPresidentReappraisalDecisionEvent"
      @changedVice="changedViceEvent">
    </president-decision>
    <el-form-item label="Επιλογή αξιολογητή" v-if="presidentJudgement.decision_type === 'Παραπομπή σε Αξιολογητή'">
      <el-select v-model="presidentJudgement.assignedTo.uid" filterable>
        <el-option v-for="user in usersToAssign" :key="user.id" :value="user.id" :label="user.surname + ' ' + user.firstname + ' - ' + user.specialty.name">
        </el-option>
      </el-select>
    </el-form-item>
    <div v-if="fromPrintDecision">
      <!-- can be taken to a sub-component -->
      <el-form-item label="Σχόλιο Καταχωρητή">
        <el-input
          v-model="judgementFromPrintDecision.comment"
          type="textarea" disabled size="large">
        </el-input>
      </el-form-item>
      <el-form-item class="short-line-height" label="Αξιολογητές προς αποζημίωση" v-if="evaluatorsToPay.length !== 0">
        <el-checkbox-group v-model="checkedEvaluators" @change="checkedEvaluatorsChanged">
          <el-checkbox class="el-checkbox__wrapped short-line-height" v-for="evaluator in evaluatorsToPay" :label="evaluator.id" :key="evaluator.id" :checked="evaluator.id === lastEvaluator.id">{{evaluator.surname + ' ' + evaluator.name}}</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <!-- previous user apps -->
      <el-form-item label="Προηγούμενες αιτήσεις" v-if="workingApplication.usersAllApplications !== []">
        <el-table :data="tableData" style="width: 80%">
          <el-table-column type="expand">
            <template slot-scope="props">
              <p>Πρωτόκολλο: {{ props.row.protocol }}</p>
              <p>Ημερομηνία πρωτοκόλλου: {{ props.row.protocol_date }}</p>
              <p>Id αίτησης: {{ props.row.id }}</p>
              <el-button type="text" @click="loadPreviousApp(props.row.id)">Προβολή</el-button>
            </template>
          </el-table-column>
          <el-table-column label="Τύπος αίτησης" prop="grApplicationType"></el-table-column>
          <el-table-column label="Κατάσταση" prop="applicationStatus"></el-table-column>
        </el-table>
      </el-form-item>
      <el-dialog :visible.sync="showPreviousApp" width="90%" v-if="showPreviousApp">
        <el-card class="box-card bg-purple" v-loading="loadingSearchedApplication">
          <div class="text item">
            <el-tabs v-model="activeName" :stretch="true" v-if="showSearchedApplication">
              <el-tab-pane label="Προσωπικά Στοιχεία" name="first">
                <personal-details :personalDetails="searchedApplication.personalDetails"></personal-details>
              </el-tab-pane>
              <el-tab-pane label="Τίτλος Σπουδών" name="second"
                v-if="searchedApplication.applicationType !== 'reappraisal' && searchedApplication.applicationType !== 'compensatory'">
                <titles :application="searchedApplication"></titles>
              </el-tab-pane>
              <el-tab-pane label="Συνυποβολή Τίτλου" name="third"
                v-if="searchedApplication.degreeType === 'bachelor' && searchedApplication.consideration === true &&
                  searchedApplication.applicationType !== 'reappraisal'">
                <title-consideration :application="searchedApplication"></title-consideration>
              </el-tab-pane>
              <el-tab-pane label="Επισυναπτόμενα" name="fourth">
                <attached-documents :userComment="searchedApplication.userComment" :attachedDocumentsTable="attachedDocumentsTable"
                  :appId="searchedApplication.id" :role="role" :neededDocuments="searchedApplication.neededDocuments">
                </attached-documents>
              </el-tab-pane>
              <el-tab-pane label="Ιστορικό" name="fifth" :lazy="true">
                <history-line :applicationHistory="searchedAppHistory"></history-line>
              </el-tab-pane>
              <el-tab-pane label="Σχετική αίτηση" name="seventh" :lazy="true"
                v-if="searchedApplication.applicationType === 'reappraisal' || searchedApplication.applicationType === 'compensatory'">
                <relevant-app :relevantApp="searchedApplication.relevantApplication"></relevant-app>
              </el-tab-pane>
            </el-tabs>
          </div>
        </el-card>
      </el-dialog>
      <!-- digital signature -->
      <document-signing
        :url="signUrl"
        :config="signingConfiguration"
        :data="{ ac_iDs: checkedEvaluators }"
        @signed-successfully="documentSignedSuccessfully"
        @signing-error="documentSignError">
      </document-signing>
    </div>
    <div v-if="!fromPrintDecision && !fromAcademicDirectorReappraisal">
      <!-- can be taken to a sub-component -->
      <el-form-item label="Εσωτερικό Σχόλιο" size="large">
        <el-input
          type="textarea"
          :autosize="{ minRows: 2, maxRows: 4 }"
          placeholder="Εισάγετε το σχόλιό σας"
          v-model="internalComment">
        </el-input>
      </el-form-item>
      <el-form-item v-if="fromSpecialReappraisalBoard" label="Σχόλιο επιστροφής" size="large">
        <el-input
          class="return-comment"
          type="textarea"
          :autosize="{ minRows: 3, maxRows: 4 }"
          placeholder="Σχόλιο επιστροφής της αίτησης στον Πρόεδρο (υποχρεωτικό)"
          disabled
          v-model="returnComment">
        </el-input>
      </el-form-item>
      <el-form-item label='Στην Αναμονή'>
        <el-checkbox  v-model="presidentJudgement.queue" @change='toggleQueue' label='Ναι' border=''>
        </el-checkbox>
      </el-form-item>
      <el-form-item label='Χρώμα'>
        <el-input v-model="presidentJudgement.color" placeholder='Εισάγετε χρώμα' >
        </el-input>
      </el-form-item>
    </div>
    <div v-if="(!reappraise && !isPostExam) || (isPostExam && fromViewer) || (reappraise && (fromViewer || fromSpecialReappraisalBoard))">
      <el-form-item>
        <el-checkbox
          label='Επιθυμώ να αποδεσμεύσω την αίτηση'
          v-model='releaseChecked'>
        </el-checkbox>
      </el-form-item>
      <hr>
    </div>
    <div style="text-align: center;">
      <releaseButton
        v-if="(!reappraise && !fromPrintDecision) || (reappraise && (fromViewer || fromSpecialReappraisalBoard))"
        releaseOrReroute="release"
        popoverContent="Είστε σίγουροι ότι θέλετε να την αποδεσμεύσετε στον προέλεγχο;
          Αν ναι το σχόλιο για τον λόγο της αποδέσμευσης είναι υποχρεωτικό!"
        tooltipContent="Η αίτηση θα επιστρέψει στον προέλεγχο"
        :releaseChecked="releaseChecked"
        :workingApplicationId="workingApplication.id"
        releaseByUser="president"
        @releasedDoc="releaseOk">
      </releaseButton>
      <releaseButton v-if="!reappraise && !isPostExam"
        releaseOrReroute="reroute"
        popoverContent="Είστε σίγουροι ότι θέλετε να την αποδεσμεύσετε στον Χειριστή;
          Αν ναι το σχόλιο για τον λόγο της αποδέσμευσης είναι υποχρεωτικό!"
        tooltipContent="Η αίτηση θα επιστρέψει στον Χειριστή"
        :releaseChecked="releaseChecked && hasProponent"
        :workingApplicationId="workingApplication.id"
        releaseByUser="president"
        @releasedDoc="releaseOk">
      </releaseButton>
      <el-button
        size="mini" type="primary" round=""
        @click="tempSave"
        :disabled='false'
        v-if="!fromPrintDecision && !fromAcademicDirectorReappraisal"
      >
        Προσωρινή Αποθήκευση
      </el-button>
      <el-button
        size="mini" round="" type="primary"
        @click="finalSave"
        :disabled='isDisabled'
        v-if="!fromPrintDecision"
      >
        Οριστική Υποβολή
      </el-button>
    </div>
  </el-form>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import axios from 'axios'
import internalComments from '../common/internalComments'
import sharedMethods from '../common/sharedMethods.js'
import releaseButton from '../base/releaseButton'
import Proposals from '../common/Proposals'
import dictionary from '../../store/dictionary'
import PresidentDecision from './PresidentDecision'
import DocumentSigning from '../common/DocumentSigning.vue'
import PersonalDetails from '../common/PersonalDetails'
import Titles from '../common/Titles'
import TitleConsideration from '../common/TitleConsideration'
import AttachedDocuments from '../common/AttachedDocuments'
import HistoryLine from '../common/HistoryLine'
import RelevantApp from '../common/RelevantApp.vue'
import ReappraisalBoardSelector from '../common/ReappraisalBoardSelector.vue'

export default {
  components: {
    internalComments,
    releaseButton,
    Proposals,
    dictionary,
    PresidentDecision,
    DocumentSigning,
    PersonalDetails,
    Titles,
    TitleConsideration,
    AttachedDocuments,
    HistoryLine,
    RelevantApp,
    ReappraisalBoardSelector
  },
  mixins: [sharedMethods],
  props: ['specialProponents', 'academicAreas', 'vicePresidentsA', 'vicePresidentsB', 'finalDecisions', 'isReappraisal', 'isPostExam', 'isSecondReappraisal'],
  mounted () {
    if (!this.isReappraisal && !this.isPostExam) {
      if (this.presidentJudgement.academicField.name === null) {
        this.toggleChecked(true)
      }
    } else {
      const lastStep = this.workingApplication.applicationHistory.slice(-1)[0]
      const board = lastStep.judgment.reappraisalBoard
      if (board) {
        this.leaderId = board.coordinator
        this.selectedEmployees.push(...board.members)
      }
      if (!this.workingApplication.overdue) {
        this.getAvailableEmployees()
      } else {
        if (this.presidentJudgement.acceptOverdue) {
          this.getAvailableEmployees()
        }
      }
    }
    this.listEvaluators()
  },
  data () {
    return {
      selectedBoard: {
        coordinator: null,
        members: []
      },
      isBoardComplete: false,
      availableEmployees: [],
      fixedMembers: [],
      isAvailableEmployeesLoaded: false,
      leaderId: '',
      selectedEmployees: [],
      isSaving: false,
      signingConfiguration: {
        sectionTitle: 'Ψηφιακή υπογραφή',
        buttonCaption: 'Υπογραφή & Ολοκλήρωση',
        useAfterSuccess: false
      },
      modified: false,
      presidentComment: '',
      showRelease: false,
      releaseChecked: false,
      releaseComment: '',
      assignedToVicePresident: null,
      usersToAssign: [],
      showPreviousApp: false,
      activeName: 'first',
      role: '',
      evaluatorsToPay: [],
      checkedEvaluators: [],
      evaluatorsInvolved: []
    }
  },
  methods: {
    gradeLabel () {
      if (this.isPostExam) {
        return 'Τελικός βαθμός (μετά από εξετάσεις)'
      }
      return 'Βαθμός πτυχίου'
    },
    gradeDescriptionLabel () {
      if (this.isPostExam) {
        return 'Χαρακτηρισμός (μετά από εξετάσεις)'
      }
      return 'Χαρακτηρισμός'
    },
    async addSortedEmployees (roleId, roleName) {
      try {
        let employees = []
        const response = await axios.get(`${this.BASE_URL}/roles/${roleId}`)
        employees = Array.isArray(response.data.data)
          ? response.data.data
          : Object.values(response.data.data)
        const mapped = employees.map(emp => {
          let specialtyName = null
          if (roleId === 4) {
            specialtyName = emp.specialty && emp.specialty.name ? emp.specialty.name : null
          }
          const fullName = `${emp.surname} ${emp.firstname} (${specialtyName || roleName})`
          return {
            id: emp.id,
            name: fullName
          }
        })

        if (this.workingApplication.legalIssue) {
          if (roleId === 6) {
            this.fixedMembers.push(mapped[0].id)
            this.leaderId = mapped[0].id
          }
          if (roleId === 17) {
            this.fixedMembers.push(mapped[0].id)
          }
        }
        const sorted = mapped.sort((a, b) => a.name.localeCompare(b.name))
        this.availableEmployees.push(...sorted)
      } catch (error) {
        console.error(`Σφάλμα κατά τη φόρτωση των χρηστών του ρόλου ${roleName}:`, error)
      }
    },
    async getAvailableEmployees () {
      this.availableEmployees = []
      this.isAvailableEmployeesLoaded = false

      const loadEmployees = async () => {
        if (this.workingApplication.legalIssue) {
          await this.addSortedEmployees(6, 'Αντιπρόεδρος')
          await this.addSortedEmployees(17, 'Δ/ντής Ακαδ. Αναγνώρισης')
          await this.addSortedEmployees(20, 'Μέλος ΔΣ')
        } else {
          await this.addSortedEmployees(4, 'Αξιολογητής')
        }
        const involvedConsultants = new Set(this.getInvolvedConsultantsOnRelevantApp())
        this.availableEmployees = this.availableEmployees.filter(employee => !involvedConsultants.has(employee.id))
        this.isAvailableEmployeesLoaded = true
      }

      await loadEmployees()
    },
    getInvolvedConsultantsOnRelevantApp () {
      let consultants = []
      const history = this.workingApplication.relevantApplication.applicationHistory
      history.forEach(element => {
        if (element.applicationStatus === 'consultantW_President' &&
          history[history.indexOf(element) + 1].applicationStatus === 'presidentW_Consultant') {
          consultants.push(element.user.id)
        }
      })
      return consultants
    },
    handleBoardChange (obj) {
      this.selectedBoard = {
        coordinator: obj.leader,
        members: obj.members
      }
      this.isBoardComplete = obj.isComplete
    },
    checkedEvaluatorsChanged () {
    },
    listEvaluators () {
      this.workingApplication.applicationHistory.slice(0).reverse().forEach(element => {
        if (element.applicationStatus === 'consultantW_President' && this.workingApplication.applicationHistory[this.workingApplication.applicationHistory.indexOf(element) + 1].applicationStatus === 'presidentW_Consultant') {
          this.evaluatorsInvolved.push(element)
        }
      })
      this.evaluatorsInvolved.forEach(evaluatorStep => {
        if (evaluatorStep.judgment.proposal !== null && this.evaluatorsToPay.findIndex(i => i.id === evaluatorStep.user.id) === -1) {
          this.evaluatorsToPay.push(evaluatorStep.user)
        }
      })
    },
    loadPreviousApp (val) {
      this.$store.dispatch('LOAD_SEARCHED_APPLICATION', val)
      this.activeName = 'first'
      this.showPreviousApp = true
      console.log(this.showPreviousApp)
    },
    documentSignedSuccessfully () {
      this.$store.dispatch('LOAD_ASSIGNED_APPLICATIONS', this.activeLane)
      this.frontEndSuccessMsg('Το έγγραφο υπογράφηκε με επιτυχία!')
    },
    documentSignError (err) {
      this.frontEndError(err.response.data.message.text[0])
    },
    changedPresidentDecisionEvent (presidentDecision, presidentDecisionType, evaluators, depName, assignedToVicePresident) {
      this.presidentJudgement.decision = presidentDecision
      this.presidentJudgement.decision_type = presidentDecisionType
      this.usersToAssign = evaluators
      this.presidentJudgement.departmentName = depName
      this.assignedToVicePresident = assignedToVicePresident
    },
    changedPresidentReappraisalDecisionEvent (presidentDecision, presidentDecisionType, depName) {
      this.presidentJudgement.decision = presidentDecision
      // this.presidentJudgement.reappraisalDecisionType = presidentDecisionType
      this.$set(this.presidentJudgement, 'reappraisalDecisionType', presidentDecisionType)
      this.presidentJudgement.departmentName = depName
      console.log('>>> Reappraisal decision type:', this.presidentJudgement.reappraisalDecisionType)
    },
    changedViceEvent (assignedToVicePresident) {
      this.presidentJudgement.assignedTo.role = assignedToVicePresident
    },
    releaseOk () {
      this.$emit('releasedDoc', true)
      this.$emit('close-dialog')
    },
    toggleSpecialProponent (val) {
      this.presidentJudgement.assignedTo.id = val
    },
    toggleChecked (val) {
      this.checked = val
      if (this.checked === true) {
        this.presidentJudgement.academicField.name = this.precheckerJudgement.academicField.name
        this.presidentJudgement.academicField.id = this.precheckerJudgement.academicField.id
      }
    },
    toggleQueue (val) {
    },
    toggleOverdue (val) {
      if (this.presidentJudgement.acceptOverdue) {
        this.fixedMembers = []
        this.leaderId = ''
        this.getAvailableEmployees()
      }
      console.log(this.presidentJudgement.assignedTo.role)
    },
    toggleAcademicField (val) {
      let name = this.academicAreas.find(area => area.id === val).name
      this.presidentJudgement.academicField = {id: val, name: name}
    },
    tempSave () {
      let payload
      if (!this.isReappraisal) {
        if (this.fromProponent || this.fromAcademicDirector || this.fromConsultant) {
          if (this.presidentJudgement.decision_type === 'Παραπομπή σε Αξιολογητή') {
            if (this.presidentJudgement.assignedTo.uid !== null) {
              this.presidentJudgement.assignedTo.role = 'AcademicConsultant'
            } else {
              this.presidentJudgement.assignedTo.role = null
            }
          } else {
            this.presidentJudgement.assignedTo.role = null
            this.presidentJudgement.assignedTo.uid = null
          }
        }
        payload = {
          internalComment: (this.fromConsultantOverdue && this.presidentJudgement.internalComment === null) ? this.presidentJudgement.internalComment = 'Ο πρώτος κύκλος αξιολόγησης απέβη άκαρπος. Παρακαλώ ολοκληρώστε την αξιολόγηση εντός 15 ημερών ως β΄ αξιολογητής.' : this.presidentJudgement.internalComment,
          decision: this.presidentJudgement.decision ? this.presidentJudgement.decision : null,
          decision_type: this.presidentJudgement.decision_type ? this.presidentJudgement.decision_type : null,
          departmentName: this.presidentJudgement.departmentName ? this.presidentJudgement.departmentName : null,
          academicField: {
            name: this.presidentJudgement.academicField.name,
            id: this.presidentJudgement.academicField.id
          },
          assignedTo: {
            role: this.presidentJudgement.assignedTo.role,
            uid: this.presidentJudgement.assignedTo.uid
          },
          color: this.presidentJudgement.color,
          queue: this.presidentJudgement.queue
        }
      } else if (this.isReappraisal) {
        if (this.workingApplication.overdue && !this.presidentJudgement.acceptOverdue) {
          this.selectedBoard = {
            coordinator: null,
            members: []
          }
        }
        payload = {
          overdue: this.workingApplication.overdue,
          internalComment: this.presidentJudgement.internalComment,
          decisionOverdue: this.presidentJudgement.decisionOverdue ? this.presidentJudgement.decisionOverdue : null,
          // acceptOverdue: this.presidentJudgement.acceptOverdue || false,
          acceptOverdue: this.overdueAccepted || false,
          departmentName: null,
          assignedTo: {
            role: this.presidentJudgement.assignedTo.role ? this.presidentJudgement.assignedTo.role : null,
            uid: null
          },
          color: this.presidentJudgement.color,
          queue: this.presidentJudgement.queue,
          decision: this.presidentJudgement.decision ? this.presidentJudgement.decision : null,
          reappraisalDecisionType: this.presidentJudgement.reappraisalDecisionType ? this.presidentJudgement.reappraisalDecisionType : null,
          academicField: {
            name: null,
            id: null
          }
        }
        if (this.fromViewer || this.fromSpecialReappraisalBoard) {
          payload = {
            reappraisalBoard: this.selectedBoard,
            ...payload
          }
        }
      }
      // console.log('temp payload', payload)
      axios.put(
        `${this.BASE_URL}/presidents/uid/applications/${this.workingApplication.id}/temp`, { judgment: payload }
      ).then((response) => {
        this.$store.dispatch('LOAD_ASSIGNED_APPLICATIONS', this.activeLane)
        this.$store.dispatch('LOAD_WORKING_APPLICATION', this.workingApplication.id)
        this.frontEndSuccessMsg('Τα δεδομένα αποθηκεύτηκαν με επιτυχία')
      }).catch(err => {
        this.frontEndError('Σφάλμα κατά την προσωρινή αποθήκευση')
        this.catchError(err)
      })
    },
    finalSave () {
      let payload
      if (!this.isReappraisal) {
        if (this.fromPrechecker) {
          this.presidentJudgement.assignedTo.role = 'SpecialProponent'
          this.presidentJudgement.decision_type = null
        } else if (this.fromProponent || this.fromAcademicDirector || this.fromConsultant) {
          if (this.presidentJudgement.decision_type === 'Παραπομπή σε Αξιολογητή') {
            this.presidentJudgement.assignedTo.role = 'AcademicConsultant'
            // this.presidentJudgement.assignedTo.uid = null
          } else if (this.presidentJudgement.decision_type === 'Συμφωνία') {
            this.presidentJudgement.assignedTo.role = 'PrintDecision'
            this.presidentJudgement.assignedTo.uid = null
          }
        } else if (this.fromBoard) {
          if (this.presidentJudgement.decision_type === 'Συμφωνία') {
            this.presidentJudgement.assignedTo.role = 'PrintDecision'
            this.presidentJudgement.assignedTo.uid = null
          } else if (this.presidentJudgement.decision_type === 'Παραπομπή σε Εκτελεστική Επιτροπή') {
            this.presidentJudgement.assignedTo.role = 'ExecutiveBoardMember'
            this.presidentJudgement.assignedTo.uid = null
          } else if (this.presidentJudgement.decision_type === 'Μη Ομοφωνία Εκτελεστικής Επιτροπής/Παραπομπή σε Τμήμα') {
            if (this.presidentJudgement.assignedTo.role === 'VicePresidentA') {
              this.presidentJudgement.assignedTo.uid = this.vicePresidentsA[0].id
            } else {
              this.presidentJudgement.assignedTo.uid = this.vicePresidentsB[0].id
            }
          }
        } else if (this.fromVice || this.fromAcademicDirector || this.fromAcademicDirector2) {
          this.presidentJudgement.assignedTo.role = 'PrintDecision'
          this.presidentJudgement.assignedTo.uid = null
        } else if (this.fromConsultantOverdue) {
          this.presidentJudgement.assignedTo.role = 'AcademicConsultant'
        }
        payload = {
          internalComment: (this.fromConsultantOverdue && this.presidentJudgement.internalComment === null) ? this.presidentJudgement.internalComment = 'Ο πρώτος κύκλος αξιολόγησης απέβη άκαρπος. Παρακαλώ ολοκληρώστε την αξιολόγηση εντός 15 ημερών ως β΄ αξιολογητής.' : this.presidentJudgement.internalComment,
          decision: this.presidentJudgement.decision ? this.presidentJudgement.decision : null,
          decision_type: this.presidentJudgement.decision_type ? this.presidentJudgement.decision_type : null,
          departmentName: this.presidentJudgement.departmentName ? this.presidentJudgement.departmentName : null,
          academicField: {
            name: this.presidentJudgement.academicField.name,
            id: this.presidentJudgement.academicField.id
          },
          assignedTo: {
            role: this.presidentJudgement.assignedTo.role,
            uid: this.presidentJudgement.assignedTo.uid
          },
          color: this.presidentJudgement.color,
          queue: this.presidentJudgement.queue
        }
      } else if (this.isReappraisal) {
        // if (this.fromPrechecker) {
        //   if ((this.workingApplication.overdue && !this.presidentJudgement.acceptOverdue) || this.isSecondReappraisal) {
        //     this.presidentJudgement.assignedTo.role = 'PrintDecision'
        //   }
        // } else if (this.fromBoard || this.fromVice) {
        //   this.presidentJudgement.assignedTo.role = 'PrintDecision'
        // }
        if (this.fromViewer || this.fromSpecialReappraisalBoard) {
          if (this.workingApplication.overdue && !this.presidentJudgement.acceptOverdue) {
            this.presidentJudgement.assignedTo.role = 'PrintDecision'
          } else {
            this.presidentJudgement.assignedTo.role = 'SpecialReappraisalBoardMember'
            this.presidentJudgement.assignedTo.uid = this.selectedBoard.coordinator
          }
        }
        if (this.fromAcademicDirectorReappraisal) {
          this.presidentJudgement.assignedTo.role = 'PrintDecision'
        }
        payload = {
          overdue: this.workingApplication.overdue,
          internalComment: this.presidentJudgement.internalComment,
          decisionOverdue: this.presidentJudgement.decisionOverdue ? this.presidentJudgement.decisionOverdue : null,
          acceptOverdue: this.overdueAccepted || false,
          departmentName: null,
          assignedTo: {
            role: this.presidentJudgement.assignedTo.role,
            uid: this.presidentJudgement.assignedTo.uid ? this.presidentJudgement.assignedTo.uid : null
          },
          color: this.presidentJudgement.color,
          queue: this.presidentJudgement.queue,
          decision: this.presidentJudgement.decision ? this.presidentJudgement.decision : null,
          reappraisalDecisionType: this.presidentJudgement.reappraisalDecisionType ? this.presidentJudgement.reappraisalDecisionType : null,
          academicField: {
            name: null,
            id: null
          }
        }
      }
      console.log(`>>> Final payload ${this.workingApplication.id}`, payload)
      this.$confirm(this.saveMessage,
        'Προειδοποίηση', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Άκυρο',
          type: 'warning'
        }).then(() => {
        if (this.isReappraisal &&
          !this.fromAcademicDirectorReappraisal &&
          !this.fromPrintDecision &&
          ((this.fromViewer || this.fromSpecialReappraisalBoard) && (!this.workingApplication.overdue || (this.workingApplication.overdue && this.presidentJudgement.acceptOverdue)))) {
          const appId = this.workingApplication.id
          const protocol = this.workingApplication.protocol
          const getBoardUrl = `${this.BASE_URL}/reappraisal_boards?application_id=${appId}`
          const createBoardUrl = `${this.BASE_URL}/reappraisal_boards`
          const addMembersUrl = `${this.BASE_URL}/reappraisal_boards/`
          const finalSaveUrl = `${this.BASE_URL}/presidents/uid/applications/${appId}/final`

          const reappraisalboard = {
            // name: protocol || `Επιτροπή για την αίτηση ${appId}`,
            name: `[${appId}] ${protocol}` || `Επιτροπή για την αίτηση ${appId}`,
            application_id: appId
          }
          const members = {
            membersId: [
              this.selectedBoard.coordinator,
              ...this.selectedBoard.members.filter(id => id !== this.selectedBoard.coordinator)]
          }
          const savePayload = {
            judgment: payload
          }

          this.isSaving = true

          // Check if this app has a board
          axios.get(getBoardUrl)
            .then(getBoardResponse => {
              const dataArray = getBoardResponse.data && getBoardResponse.data.data

              if (Array.isArray(dataArray) && dataArray.length > 0) {
                const boardId = dataArray[0].id
                console.log('>>> Βρέθηκε επιτροπή για την αίτηση')

                return axios.put(addMembersUrl + boardId, members)
              } else {
                return axios.post(createBoardUrl, reappraisalboard)
                  .then(createResponse => {
                    const boardId = createResponse.data.data.id
                    console.log('>>> Η επιτροπή δημιουργήθηκε με επιτυχία')

                    return axios.put(addMembersUrl + boardId, members)
                  })
              }
            })
            .then(addMembersResponse => {
              console.log('>>> Τα μέλη προστέθηκαν με επιτυχία')
              return axios.put(finalSaveUrl, savePayload)
            })
            .then(response => {
              this.frontEndSuccessMsg('Η αίτηση προωθήθηκε με επιτυχία.')
              this.$store.dispatch('LOAD_ASSIGNED_APPLICATIONS', this.activeLane)
            })
            .catch(err => {
              this.frontEndError('Σφάλμα κατά τη διαδικασία της οριστικής αποθήκευσης')
              this.catchError(err)
            })
            .finally(() => {
              this.isSaving = false
            })
        } else {
          axios.put(
            `${this.BASE_URL}/presidents/uid/applications/${this.workingApplication.id}/final`,
            { judgment: payload }
          ).then((response) => {
            this.frontEndSuccessMsg('Η αίτηση προωθήθηκε με επιτυχία')
            this.$store.dispatch('LOAD_ASSIGNED_APPLICATIONS', this.activeLane)
          }).catch(err => {
            this.frontEndError('Σφάλμα κατά την οριστική αποθήκευση')
            this.catchError(err)
          })
        }
      })
    },
    catchError (err) {
      this.backendError(err)
      throw err
    }
  },
  computed: {
    overdueAccepted () {
      if (!this.isReappraisal) {
        return false
      }
      if ((this.lastState === 'presidentW_Viewer') || (this.lastState === 'presidentW_ReappraisalBoard')) {
        return this.presidentJudgement.acceptOverdue || false
      }
      const targetStatus = ['presidentW_Viewer', 'presidentW_ReappraisalBoard']
      const foundStep = this.workingApplication.applicationHistory.slice().reverse()
        .find(step => targetStatus.includes(step.applicationStatus))
      const result = foundStep && foundStep.judgment && foundStep.judgment.acceptOverdue
      return result
    },
    tableData () {
      if (this.workingApplication.usersAllApplications !== null) {
        return this.workingApplication.usersAllApplications.map(app => {
          return {
            applicationStatus: dictionary[app.applicationStatus],
            grApplicationType: app.grApplicationType,
            protocol: app.protocol,
            protocol_date: app.protocol_date,
            id: app.id
          }
        })
      } else {
        return []
      }
    },
    attachedDocumentsTable () {
      return this.searchedApplication.attachedDocuments.slice(0).map(doc =>
        ({name: doc.name,
          type: doc.type,
          date: doc.date,
          applicantComment: doc.applicantComment,
          precheckerChecked: doc.precheckerChecked,
          precheckerComment: doc.precheckerComment,
          id: doc.id
        })
      )
    },
    signUrl () {
      return `${this.BASE_URL}/digitalSignature/${this.currentUser.id}/applications/${this.workingApplication.id}/digitalSignFinalAct`
    },
    reappraise () {
      return this.isReappraisal
    },
    overdue () {
      return this.workingApplication.overdue
        ? 'Ναι'
        : 'Όχι'
    },
    showDecision () {
      if (this.isPostExam) {
        return this.fromViewer
      } else if (this.isReappraisal) {
        if (this.fromPrechecker && this.isSecondReappraisal) {
          if (this.workingApplication.overdue && this.presidentJudgement.acceptOverdue) {
            return true
          } else if (!this.workingApplication.overdue) {
            return true
          }
        } else if (this.fromBoard) {
          return true
        } else if (this.fromVice) {
          return true
        } else if (this.fromAcademicDirectorReappraisal) {
          return true
        } else return false
      } else if (!this.isReappraisal) {
        if (this.fromProponent || this.fromAcademicDirector ||
          this.fromBoard || this.fromVice ||
          this.fromConsultant || this.fromConsultantOverdue ||
          this.fromAcademicDirector2) {
          return true
        } else return false
      }
    },
    hasProponent () {
      return !!this.workingApplication.applicationHistory
        .find(step => step.applicationStatus === 'proponentW_President')
    },
    validatedFinalDecisions () {
      if (!this.isReappraisal && !this.isPostExam) {
        if (this.workingApplication.degreeType === 'bachelor') {
          return this.finalDecisions.filter(decision => [12, 13, 16, 17].includes(decision.id))
          // return this.finalDecisions.filter(decision => decision.id <= 4)
        } else if (this.workingApplication.degreeType === 'master') {
          return this.finalDecisions.filter(decision => [14, 16].includes(decision.id))
          // return this.finalDecisions.filter(decision => decision.id === 4 || decision.id === 6)
        } else if (this.workingApplication.degreeType === 'phd') {
          return this.finalDecisions.filter(decision => [15, 16].includes(decision.id))
          // return this.finalDecisions.filter(decision => decision.id === 4 || decision.id === 5)
        } else {
          return this.finalDecisions
        }
      } else if (this.isReappraisal) {
        return this.finalDecisions.filter(decision => [18, 19, 20, 21, 22].includes(decision.id))
        // if (this.workingApplication.relevantAppl.specialFields.degreeType === 'bachelor') {
        // // if (this.workingApplication.relevantAppl.specialFields.degreeType === 'bachelor' ||
        // // this.workingApplication.relevantAppl.specialFields.relevantAppl.specialFields.degreeType === 'bachelor') {
        //   return this.finalDecisions.filter(decision => [7, 8, 9].includes(decision.id))
        // } else if (this.workingApplication.relevantAppl.specialFields.degreeType === 'master') {
        // // } else if (this.workingApplication.relevantAppl.specialFields.degreeType === 'master' ||
        // // this.workingApplication.relevantAppl.specialFields.relevantAppl.specialFields.degreeType === 'master') {
        //   return this.finalDecisions.filter(decision => decision.id === 11)
        // } else if (this.workingApplication.relevantAppl.specialFields.degreeType === 'phd') {
        // // } else if (this.workingApplication.relevantAppl.specialFields.degreeType === 'phd' ||
        // // this.workingApplication.relevantAppl.specialFields.relevantAppl.specialFields.degreeType === 'phd') {
        //   return this.finalDecisions.filter(decision => decision.id === 10)
        // }
      } else if (this.isPostExam) {
        return this.finalDecisions.filter(decision => [12, 13].includes(decision.id))
      }
    },
    reappDegreeType () {
      let result = null
      const relevantApplication = this.workingApplication.relevantAppl
      if (relevantApplication && relevantApplication.specialFields) {
        result = relevantApplication.specialFields.degreeType
      }
      return result
    },
    checked: {
      get: function (val) {
        if (this.presidentJudgement.academicField.name === this.precheckerJudgement.academicField.name) {
          return true
        } else {
          return false
        }
      },
      set: function (value) {
        if (value) {
          this.presidentJudgement.academicField.name = this.precheckerJudgement.academicField.name
        } else {
          if (this.presidentJudgement.academicField.name === this.precheckerJudgement.academicField.name) {
            this.presidentJudgement.academicField.name = null
          }
        }
      }
    },
    saveMessage () {
      if (this.fromViewer || this.fromSpecialReappraisalBoard) {
        if (this.isReappraisal) {
          if (this.workingApplication.overdue) {
            if (!this.presidentJudgement.acceptOverdue) {
              return 'Η αίτηση απορρίπτεται ως ΕΚΠΡΟΘΕΣΜΗ και δρομολογείται προς εκτύπωση επιστολής απόρριψης. Είστε σίγουροι ότι θέλετε να συνεχίσετε;'
            } else {
              if (this.isBoardComplete) {
                return 'Θα δημιουργηθεί η προτεινόμενη Ειδική Επιτροπή Επανεξέτασης και η αίτηση θα προωθηθεί σε αυτήν. Θέλετε να συνεχίσετε;'
              }
            }
          } else {
            if (this.isBoardComplete) {
              return 'Θα δημιουργηθεί η προτεινόμενη Ειδική Επιτροπή Επανεξέτασης και η αίτηση θα προωθηθεί προς αυτήν. Θέλετε να συνεχίσετε;'
            }
          }
        }
      }
      if (this.fromAcademicDirectorReappraisal) {
        return 'Η αίτηση προωθείται για εκτύπωση. Είστε σίγουροι ότι θέλετε να συνεχίσετε;'
      }
      if (this.presidentJudgement.assignedTo.role === 'SpecialProponent') {
        return this.checked
          ? 'Αποδοχή πρότασης Ακαδημαϊκής Περιοχής Υπαλλήλου Προελέγχου. Η αίτηση δρομολογείται προς τον Χειριστή'
          : 'Μη αποδοχή πρότασης Ακαδημαϊκής Περιοχής Υπαλλήλου Προελέγχου. Ορισμός νέας περιοχής:  ' +
           this.presidentJudgement.academicField.name +
          '. Η αίτηση δρομολογείται προς τον Χειριστή'
      }
      if (this.fromProponent && this.presidentJudgement.assignedTo.role === 'ExecutiveBoardMember') {
        return 'Μη αποδοχή πρότασης Ειδικού Εισηγητή. Παραπομπή σε Εκτελεστική επιτροπή'
      }
      if (this.fromAcademicDirector && this.presidentJudgement.assignedTo.role === 'ExecutiveBoardMember') {
        return 'Μη αποδοχή πρότασης Ειδικού Εισηγητή. Παραπομπή σε Εκτελεστική επιτροπή'
      }
      if (this.fromProponent && this.presidentJudgement.assignedTo.role === 'PrintDecision') {
        return 'Αποδοχή πρότασης Χειριστή. Η αίτηση δρομολογείται προς εκτύπωση.'
      }
      if (this.fromAcademicDirector && this.presidentJudgement.assignedTo.role === 'PrintDecision') {
        return 'Αποδοχή πρότασης Χειριστή. Η αίτηση δρομολογείται προς εκτύπωση.'
      }
      if (this.fromBoard && this.presidentJudgement.assignedTo.role === 'ExecutiveBoardMember') {
        return 'Παραπομπή σε Εκτελεστική επιτροπή, ειστε σίγουροι ότι θέλετε να συνεχίσετε;'
      }
      if (this.fromBoard && this.presidentJudgement.assignedTo.role === 'PrintDecision') {
        return 'Αποδοχή πρότασης Εκτελεστικής Επιτροπής. Η αίτηση δρομολογείται προς εκτύπωση.' +
          'Ειστε σίγουροι ότι θέλετε να συνεχίσετε;'
      }
      if (
        this.fromBoard &&
        (this.presidentJudgement.assignedTo.role === 'VicePresidentA' ||
          this.presidentJudgement.assignedTo.role === 'VicePresidentB')
      ) {
        return 'Ανάθεση σε Αντιπρόεδρο, ειστε σίγουροι ότι θέλετε να συνεχίσετε;'
      }
      if (this.fromVice && this.presidentJudgement.assignedTo.role === 'PrintDecision') {
        return 'Η αίτηση προωθείται για εκτύπωση, είστε σίγουροι ότι θέλετε να συνεχίσετε;'
      }
      if (this.fromPrintDecision) {
        return 'Θέλετε να αποστείλετε την ψηφιακά υπογεγραμμένη πράξη του Αρ. Πρ. Φακέλου ' +
        this.workingApplication.protocol + ' και να ενημερωθεί o χρήστης;'
      }
      if (this.fromPrechecker && this.workingApplication.overdue && this.presidentJudgement.acceptOverdue) {
        return 'Η αίτηση έγινε δεκτή παρόλο που είναι εκπρόθεσμη, ειστε σίγουροι ότι θέλετε να συνεχίσετε;'
      }
      if (this.fromPrechecker && this.workingApplication.overdue && !this.presidentJudgement.acceptOverdue) {
        return 'Η αίτηση απορρίπτεται ως εκπρόθεσμη και δρομολογείται προς εκτύπωση επιστολής απόρριψης, ειστε σίγουροι ότι θέλετε να συνεχίσετε;'
      }
      if (this.fromPrechecker && !this.workingApplication.overdue && this.isSecondReappraisal) {
        return 'Η αίτηση προωθείται για εκτύπωση, είστε σίγουροι ότι θέλετε να συνεχίσετε;'
      }
      if (this.presidentJudgement.assignedTo.role === 'AcademicConsultant') {
        return 'Η αίτηση προωθείται σε ειδικό αξιολογητή, είστε σίγουροι ότι θέλετε να συνεχίσετε;'
      }
      if (this.fromConsultant || this.fromAcademicDirector || this.fromAcademicDirector2) {
        return 'Η αίτηση προωθείται για εκτύπωση, είστε σίγουροι ότι θέλετε να συνεχίσετε;'
      }
    },
    isDisabled: function () {
      if (this.fromAcademicDirectorReappraisal) {
        if (this.isReappraisal) {
          if (this.presidentJudgement.reappraisalDecisionType === 'Εμμονή Στην Προηγούμενη Πράξη Αναγνώρισης') {
            return false
          }
          if (this.presidentJudgement.reappraisalDecisionType && this.presidentJudgement.decision) {
            return false
          }
        }
      }
      if (this.fromViewer || this.fromSpecialReappraisalBoard) {
        if (this.isReappraisal) {
          if (this.workingApplication.overdue) {
            if (!this.presidentJudgement.acceptOverdue) {
              return false
            } else {
              if (this.isBoardComplete) {
                return false
              }
            }
          } else {
            if (this.isBoardComplete) {
              return false
            }
          }
        }
      }
      if (this.fromPrechecker) {
        if (!this.isReappraisal) {
          if (this.presidentJudgement.assignedTo.uid && this.checked === true) {
            return false
          }
          if (this.checked === false && this.presidentJudgement.academicField.name) {
            return false
          }
        } else if (this.isReappraisal) {
          if (this.presidentJudgement.decisionOverdue !== null) {
            return false
          }
        }
      } else if (this.fromProponent) {
        if (!this.isReappraisal) {
          if (
            this.presidentJudgement.decision_type === 'Συμφωνία' &&
            [2, 4, 5, 6, 14, 15, 16].includes(this.presidentJudgement.decision)
          ) {
            return false
          }
          if (
            this.presidentJudgement.decision_type === 'Συμφωνία' &&
            [1, 3, 12, 13, 17].includes(this.presidentJudgement.decision) &&
            this.presidentJudgement.departmentName != null
          ) {
            return false
          }
          if (this.presidentJudgement.decision_type === 'Παραπομπή σε Αξιολογητή' && this.presidentJudgement.assignedTo.uid != null) {
            return false
          }
        } else {
          // see above command if (this.fromViewer)
        }
      } else if (this.fromBoard) {
        if (!this.isReappraisal) {
          if (this.presidentJudgement.decision_type === 'Παραπομπή σε Εκτελεστική Επιτροπή') {
            return false
          }
          if (
            this.presidentJudgement.decision_type === 'Μη Ομοφωνία Εκτελεστικής Επιτροπής/Παραπομπή σε Τμήμα' &&
            ['VicePresidentA', 'VicePresidentB'].includes(this.presidentJudgement.assignedTo.role)
          ) {
            return false
          }
          if (
            this.presidentJudgement.decision_type === 'Συμφωνία' &&
            [1, 3].includes(this.presidentJudgement.decision) &&
            this.presidentJudgement.departmentName !== null
          ) {
            return false
          }
          if (
            this.presidentJudgement.decision_type === 'Συμφωνία' &&
            [2, 4, 5, 6].includes(this.presidentJudgement.decision)
          ) {
            return false
          }
        } else if (this.isReappraisal) {
          if (this.presidentJudgement.decision === 7 && this.presidentJudgement.departmentName !== null) {
            return false
          } else if ([8, 9, 10, 11].includes(this.presidentJudgement.decision)) {
            return false
          }
        }
      } else if (this.fromVice) {
        if (!this.isReappraisal) {
          if ([1, 3].includes(this.presidentJudgement.decision) && this.presidentJudgement.departmentName !== null) {
            return false
          }
          if ([2, 4, 5, 6].includes(this.presidentJudgement.decision)) {
            return false
          }
        } else if (this.isReappraisal) {
          if (this.presidentJudgement.decision === 7 && this.presidentJudgement.departmentName !== null) {
            return false
          } else if ([8, 9, 10, 11].includes(this.presidentJudgement.decision)) {
            return false
          } else if (this.presidentJudgement.reappraisalDecisionType === 'Εμμονή Στην Προηγούμενη Πράξη Αναγνώρισης') {
            return false
          }
        }
      } else if (this.fromConsultant) {
        if (
          this.presidentJudgement.decision_type === 'Συμφωνία' &&
          [2, 4, 5, 6, 14, 15, 16].includes(this.presidentJudgement.decision)
        ) {
          return false
        }
        if (
          this.presidentJudgement.decision_type === 'Συμφωνία' &&
          [1, 3, 12, 13, 17].includes(this.presidentJudgement.decision) &&
          this.presidentJudgement.departmentName != null
        ) {
          return false
        }
        if (this.presidentJudgement.decision_type === 'Παραπομπή σε Αξιολογητή' && this.presidentJudgement.assignedTo.uid != null) {
          return false
        }
      } else if (this.fromConsultantOverdue) {
        if (this.presidentJudgement.decision_type === 'Παραπομπή σε Αξιολογητή' && this.presidentJudgement.assignedTo.uid != null) {
          return false
        }
      } else if (this.fromAcademicDirector) {
        if (
          this.presidentJudgement.decision_type === 'Συμφωνία' &&
          [2, 4, 5, 6, 14, 15, 16].includes(this.presidentJudgement.decision)
        ) {
          return false
        }
        if (
          this.presidentJudgement.decision_type === 'Συμφωνία' &&
          [1, 3, 12, 13, 17].includes(this.presidentJudgement.decision) &&
          this.presidentJudgement.departmentName != null
        ) {
          return false
        }
        if (this.presidentJudgement.decision_type === 'Παραπομπή σε Αξιολογητή' && this.presidentJudgement.assignedTo.uid != null) {
          return false
        }
      } else if (this.fromAcademicDirector2) {
        if (
          this.presidentJudgement.decision_type === 'Συμφωνία' &&
          [2, 4, 5, 6, 14, 15, 16].includes(this.presidentJudgement.decision)
        ) {
          return false
        }
        if (
          this.presidentJudgement.decision_type === 'Συμφωνία' &&
          [1, 3, 12, 13, 17].includes(this.presidentJudgement.decision) &&
          this.presidentJudgement.departmentName != null
        ) {
          return false
        }
      }
      return true
    },
    lastState () {
      return this.workingApplication.applicationHistory.slice(-1)[0].applicationStatus
    },
    prevLastState () {
      return this.workingApplication.applicationHistory.slice(-2, -1)[0].applicationStatus
    },
    prevLastState2 () {
      return this.workingApplication.applicationHistory.slice(-3, -1)[0].applicationStatus
    },
    prevLastState3 () {
      return this.workingApplication.applicationHistory.slice(-4, -1)[0].applicationStatus
    },
    fromViewer () {
      return this.lastState === 'presidentW_Viewer'
    },
    fromPrechecker () {
      return this.lastState === 'presidentW_Prechecker'
    },
    fromProponent () {
      return this.prevLastState === 'viewerW_Proponent'
    },
    fromBoard () {
      return this.prevLastState === 'viewerW_Board'
    },
    fromVice () {
      return this.prevLastState === 'viewerW_Vice'
    },
    fromConsultant () {
      return this.prevLastState === 'consultantW_President' && this.lastState === 'presidentW_Consultant' && !this.lastEvaluationStep.judgment.auto_reroute
    },
    fromConsultantOverdue () {
      return this.lastState === 'presidentW_Viewer' && this.prevLastState === 'consultantW_President' && this.lastEvaluationStep.judgment.auto_reroute
    },
    fromViceThroughBoard () {
      return this.prevLastState2 === 'viceW_Board'
    },
    fromViceThroughReappraisalBoard () {
      return this.prevLastState2 === 'viceW_ReappraisalBoard'
    },
    fromPrintDecision () {
      return this.lastState === 'presidentW_PrintDecision'
    },
    fromAcademicDirector () {
      return this.lastState === 'presidentW_AcademicDirector' && this.prevLastState === 'academicDirectorW_Proponent'
    },
    fromAcademicDirector2 () {
      return this.lastState === 'presidentW_after2fortnights'
    },
    fromAcademicDirectorReappraisal () {
      return this.lastState === 'presidentW_AcademicDirector_Reappraisal'
    },
    fromSpecialReappraisalBoard () {
      return this.lastState === 'presidentW_ReappraisalBoard'
    },
    // fromConsultant () {
    //   return this.workingApplication.applicationHistory.slice().reverse()
    //     .find(item => item.applicationStatus === 'boardW_Consultant') !== undefined
    // },
    fromConsultant2 () {
      return this.prevLastState === 'consultantW_President' && this.lastState === 'presidentW_Consultant' && this.prevLastState2 === 'presidentW_Viewer' && this.prevLastState3 === 'consultantW_President'
    },
    precheckerJudgement () {
      return this.workingApplication.applicationHistory.slice(0).reverse()
        .find(step => step.applicationStatus === 'precheckerW_').judgment
    },
    presidentJudgement (val) {
      let judgment = this.workingApplication.applicationHistory.slice(0).reverse()
        .find(step => step.applicationStatus === 'presidentW_Prechecker' ||
          step.applicationStatus === 'presidentW_Viewer' ||
          step.applicationStatus === 'presidentW_PrintDecision' ||
          step.applicationStatus === 'presidentW_Consultant' ||
          step.applicationStatus === 'presidentW_AcademicDirector' ||
          step.applicationStatus === 'presidentW_AcademicDirector_Reappraisal' ||
          step.applicationStatus === 'presidentW_ReappraisalBoard' ||
          step.applicationStatus === 'presidentW_after2fortnights')
        .judgment
      if (!judgment.hasOwnProperty('decision')) {
        this.$set(judgment, 'decision', null)
      }
      if (!judgment.hasOwnProperty('reappraisalDecisionType')) {
        this.$set(judgment, 'reappraisalDecisionType', null)
      }
      if (!judgment.hasOwnProperty('departmentName')) {
        this.$set(judgment, 'departmentName', null)
      }
      return judgment
    },
    lastEvaluationStep () {
      return this.workingApplication.applicationHistory.slice(0).reverse()
        .find(step => step.applicationStatus === 'consultantW_President')
    },
    lastEvaluationStepIndex () {
      return this.workingApplication.applicationHistory.indexOf(this.lastEvaluationStep)
    },
    nextEvaluationStepStatus () {
      return this.workingApplication.applicationHistory[(this.lastEvaluationStepIndex + 1)].applicationStatus
    },
    lastEvaluator () {
      return this.workingApplication.applicationHistory.slice(0).reverse().find(step => step.applicationStatus === 'consultantW_President').user
    },
    internalComment: {
      get () {
        return (this.fromConsultantOverdue && this.presidentJudgement.internalComment === null) ? 'Ο πρώτος κύκλος αξιολόγησης απέβη άκαρπος. Παρακαλώ ολοκληρώστε την αξιολόγηση εντός 15 ημερών ως β΄ αξιολογητής.' : this.presidentJudgement.internalComment
      },
      set (val) {
        if (val) {
          this.presidentJudgement.internalComment = val
        }
      }
    },
    returnComment () {
      return this.workingApplication.applicationHistory.slice(-2, -1)[0].reappBoardCoordinatorComment
    },
    academicDirectorJudgment () {
      return this.workingApplication.applicationHistory.slice(0).reverse()
        .find(step => step.applicationStatus === 'academicDirectorW_President' || step.applicationStatus === 'academicDirectorW_Proponent').judgment
    },
    titlesCorrespondence () {
      if (this.isReappraisal || this.isPostExam) {
        // return this.workingApplication.relevantAppl.specialFields.titlesCorrespondence
        return this.workingApplication.relevantAppl.specialFields.applicationType === 'reappraisal'
          ? this.workingApplication.relevantAppl.specialFields.relevantAppl.specialFields.titlesCorrespondence
          : this.workingApplication.relevantAppl.specialFields.titlesCorrespondence
      } else {
        return this.workingApplication.titlesCorrespondence
      }
    },
    judgementFromBoardMembers () {
      return this.workingApplication.applicationHistory.slice(0).reverse()
        .find(step => step.applicationStatus === 'boardW_Consultant' ||
          step.applicationStatus === 'boardW_President' ||
          step.applicationStatus === 'boardW_Proponent' ||
          step.applicationStatus === 'boardW_Vice')
        .judgment
    },
    judgementFromVice () {
      return this.workingApplication.applicationHistory.slice(0).reverse()
        .find(step => step.applicationStatus === 'viceW_President' || step.applicationStatus === 'viceW_Board' || step.applicationStatus === 'viceW_ReappraisalBoard').judgment
    },
    judgementFromPrintDecision () {
      return this.workingApplication.applicationHistory.slice(0).reverse()
        .find(step => step.applicationStatus === 'printDecisionW_').judgment
    },
    ...mapState([
      'activeLane',
      'workingApplication',
      'BASE_URL',
      'showSearchedApplication',
      'searchedApplication',
      'loadingSearchedApplication',
      'searchedAppHistory',
      'OVERDUE_MESSAGE'
    ]),
    ...mapGetters({ currentUser: 'currentUser' })
  }
}
</script>

<style lang="scss" scoped>
.big {
  &.el-select {
    width: 450px;
  }
}

.bigger {
  &.el-select {
    width: 620px;
  }
}

.el-checkbox__label {
  background-color: transparent;
}

/* evaluators payment styles*/
.el-checkbox__wrapped {
  margin-left: 30px;
  display: block;
}

div.short-line-height label {
  line-height: 25px;
}

.el-form-item__content {
  line-height: 20px;
}

.el-form-item__label {
    text-align: right;
    float: left;
    font-size: 14px;
    color: #606266;
    line-height: 20px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
}

.el-form-item {
  color: rgb(30, 0, 128);
  font-weight: bold;
  padding-right: 20px;
  padding-left: 10px;
}

.return-comment {
  background-color:red;
  padding: 3px;
}
</style>



// WEBPACK FOOTER //
// src/components/roleSpecific/PresidentJudgement.vue